module.exports = __webpack_public_path__ + "static/media/hod-house-w-blue-bground-icon.a3ef55a0.svg";